<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="unitId"
            search-url="/kidUnit/search?sortField=status,levelId&"
            create-url="/kidUnit/save"
            delete-url="/kidUnit/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :accept-create="false"
            :acceptView="false"
            @viewItem="viewItem"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin topic",
      formCreateName: "Thêm mới topic",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "unitOrder",
          text: "Số thứ tự các topic",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'unitName',
          text: 'Tên topic',
          sortable: false,
          search: true,
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'levelId',
          text: 'Level',
          width: "15%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "levelId",
          items: [],
          itemText: "levelName",
          itemValue: "levelId",
        },
        {
          value: 'unitContent',
          text: 'Nội dung topic',
          sortable: false,
          search: true,
          width: "20%",
          headerStyle: "text-align:center",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },


  methods: {

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới topic';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật topic';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
  },

  destroyed() {
  },
};
</script>
